"use client";

import React from "react";
import { FileText, Calendar, Truck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  id: 1,
  number: "01",
  title: "Selección",
  description: "Elija la maquinaria ideal para su faena, desde tractores de alta potencia hasta grúas horquilla 4x4.",
  icon: FileText
}, {
  id: 2,
  number: "02",
  title: "Logística",
  description: "Coordinamos el despacho técnico de los equipos directamente a su predio agrícola o zona de operación.",
  icon: Calendar
}, {
  id: 3,
  number: "03",
  title: "Operación",
  description: "Ponga en marcha su proyecto con soporte continuo y equipos listos para el trabajo pesado en terreno.",
  icon: Truck
}];
export default function In3SchrittenZuIhremNeuenZuhause() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222588" id="logística-de-entrega" className="bg-background py-24 overflow-hidden text-foreground">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-6xl">
        <div ref={ref} className={`text-center max-w-3xl mx-auto mb-20 transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 tracking-wider uppercase">
            Logística de Entrega ARRELS
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            En ARRELS impulsamos tu producción con arriendo de maquinaria agricola, desde retro excavadoras, mini, gruas horquilas, tractores y autocargables con despacho directo.
          </p>
        </div>

        <div className="relative">
          {}
          <div className="hidden md:block absolute top-8 left-[15%] right-[15%] h-[2px] border-t-2 border-dashed border-primary/30 z-0" />

          {}
          <div className="md:hidden absolute top-8 bottom-24 left-1/2 -translate-x-1/2 w-[2px] border-l-2 border-dashed border-primary/30 z-0" />

          <div className="flex flex-col md:flex-row justify-between gap-12 md:gap-8">
            {steps.map((step, i) => <div key={step.id} data-index={i} className={`relative flex flex-col items-center text-center md:w-1/3 group transition-all duration-700 delay-[${i * 200}ms] transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                {}
                <div className="absolute -top-10 left-1/2 -translate-x-1/2 text-8xl md:text-[120px] font-bold text-transparent [-webkit-text-stroke:1px_hsl(var(--primary)/0.2)] z-0 select-none transition-all duration-500 group-hover:[-webkit-text-stroke:1px_hsl(var(--primary)/0.6)] pointer-events-none font-serif">
                  {step.number}
                </div>

                {}
                <div className="relative z-10 w-16 h-16 rounded-sm bg-gradient-to-br from-primary to-primary/80 text-primary-foreground flex items-center justify-center mb-8 shadow-lg transform transition-transform duration-500 group-hover:scale-110 group-hover:shadow-primary/20">
                  <step.icon className="w-8 h-8" strokeWidth={1.5} />
                </div>

                {}
                <div className="relative z-10 px-4 bg-background/40 backdrop-blur-md md:bg-transparent md:backdrop-blur-none rounded-sm py-2">
                  <h3 className="font-default text-xl md:text-2xl font-bold text-foreground mb-3 tracking-wide uppercase">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed font-default">
                    {step.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}